import angular from "angular";

import LocaleService from "app/services/LocaleService";
import ConfigService from "app/services/ConfigService";
import lodash from "app/services/lodash";
import Constants from "app/services/Constants";
import toastr from "app/services/toastr";

export default angular.module("services.Utils", [Constants, lodash, LocaleService, ConfigService, toastr])
  .factory("Utils",
    ["_", "$log", "Constants", "LocaleService", "ConfigService", "$stateParams", "$state", "moment", "$timeout", "toastr",
      function Utils(
        _,
        $log,
        Constants,
        LocaleService,
        ConfigService,
        $stateParams,
        $state,
        moment,
        $timeout,
        toastr
      ) {
        var timeout;
        // - [ ] { } ( ) + ? . , \ ^ $ | #
        const INVALID_CHAR_REGEXP = new RegExp(
          "[-\\[\\]{}()+?.,\\\\^$|#]",
          "g"
        );

        function merge(o1, o2) {
          var keys = Object.keys(o2);
          for (var i = 0; i < keys.length; i++) {
            o1[keys[i]] = o2[keys[i]];
          }
          return o1;
        }

        function processTree(filter) {
          filter.path = [];

          if (filter.openItems && filter.openItems.selected) {
            filter.openItems.selected.forEach(function (item) {
              filter.path.push("*," + item.id + "*");
            });
          }
          delete filter.openItems;

          if (filter.closedItems && filter.closedItems.selected) {
            filter.closedItems.selected.forEach(function (item) {
              filter.path.push("*," + item.id + "*");
            });
          }
          delete filter.closedItems;

          //console.log("built path: ", filter.path, filter.closedItems);

          if (filter.path.length <= 0) {
            filter.path = undefined;
          }

          filter = flatten(filter);

          return filter;
        }

        //get TableStateQueryOptions
        //TODO: optional additional filter
        function getTSQO(tableState, _filter) {
          //console.log("Utils.getTSQO starting ",tableState, _filter);
          var qo = {
            filter: {},
            sorting: {},
            paging: {},
          };

          var filter = _filter || {};

          qo.filter = filter || {};

          if (tableState.search && tableState.search.predicateObject) {
            qo.filter = _.merge(
              tableState.search.predicateObject,
              angular.copy(filter)
            );

            qo.filter.path = [];

            if (qo.filter.openItems && qo.filter.openItems.selected) {
              qo.filter.openItems.selected.forEach(function (item) {
                qo.filter.path.push("*," + item.id + "*");
              });
            }
            delete qo.filter.openItems;

            if (qo.filter.closedItems && qo.filter.closedItems.selected) {
              qo.filter.closedItems.selected.forEach(function (item) {
                qo.filter.path.push("*," + item.id + "*");
              });
            }
            delete qo.filter.closedItems;

            //console.log("built path: ", qo.filter.path, qo.filter.closedItems);

            if (qo.filter.path.length <= 0) {
              qo.filter.path = undefined;
            }

            qo.filter = flatten(qo.filter);
            //console.log("filter: ", qo.filter, tableState.search);
          }

          if (tableState.pagination) {
            qo.filter.first = tableState.pagination.start || 0;
            qo.filter.max = tableState.pagination.number || 10;
          }
          var sortBy;
          var predicate;

          if (tableState.sort && tableState.sort.predicate) {
            predicate = tableState.sort.predicate;

            if (predicate && predicate.split("+").length > 0) {
              sortBy = predicate.split("+").map(function (predicate) {
                return (tableState.sort.reverse ? "" : "-") + predicate;
              });
            } else {
              sortBy = (tableState.sort.reverse ? "" : "-") + predicate;
            }
          }

          if (sortBy) {
            qo.filter.sort = sortBy;
          }

          //console.log("Utils.getTSQO ending");
          return qo;
        }

        function getRegexp(value) {
          if (value && value.indexOf("*") < 0) {
            return "*" + value + "*";
          } else {
            return value;
          }

          /*if (value && value.indexOf("*") < 0) {
            return "*" + replaceInvalidChars(value) + "*";
          }
          else {
            return replaceInvalidChars(value);
          }*/
        }

        function getDateField(value) {
          if (value) {
            try {
              var date = moment(
                value,
                LocaleService.getDateFormat("shortDate").toUpperCase()
              ).format("YYYY-MM-DD");
              if (date === "Invalid Date") {
                $log.error(
                  "Invalid Date: ",
                  value,
                  LocaleService.getDateFormat("shortDate").toUpperCase()
                );
                return undefined;
              } else {
                return date;
              }
            } catch (err) {
              console.error(err);
              $log.error(err);
              return undefined;
            }
          } else {
            return undefined;
          }
        }

        // TODO: move this to sem, use "_" as identifier and let this be defined by service
        var ignoredEndFilter = ConfigService.get(
          "periodicDownloads.ignoredEndFilter",
          true
        );
        var ignoredPartFilter = ConfigService.get(
          "periodicDownloads.ignoredPartFilter",
          true
        );

        // TODO: adapt logic to allow multiple ignoredFilters
        function ignoredFilter(filter) {
          return filter.indexOf(ignoredEndFilter) > -1 ||
            filter.indexOf(ignoredPartFilter) > -1
            ? true
            : false;
        }

        function replaceInvalidChars(value, filterName) {
          //TODO: WEB-3899: ignore $qfs and fields with special meaning (remove this whenever backend is fixed)
          //if (["max", "createdAt", "sort", "field", "fields", "aggr"].includes(filterName) || (filterName !== undefined && filterName.indexOf("$qf") === 0) || !_.isString(value)) {

          if (
            [
              "sort",
              "max",
              "$qf",
              "page",
              "-email",
              "path",
              "date",
              "amount",
            ].includes(filterName) ||
            !_.isString(value)
          ) {
            return value;
          } else {
            // replace the "invalid" characters with a dot => Search will work almost correct (for 99,9% it will be correct)
            let newValue = value.replace(INVALID_CHAR_REGEXP, ".");
            //let newValue = value.replace(INVALID_CHAR_REGEXP, "\$&");
            return newValue;
          }
        }

        // _qo can be an object or an object with a property .filter
        function prepareFilter(
          _qo,
          regexpFields,
          dateFields,
          sortingFields,
          ignoreDynamicFilter
        ) {
          var qo = angular.copy(_qo);

          dateFields = dateFields || [];
          regexpFields = regexpFields || [];

          var retFilter = {};

          retFilter = qo.filter || qo;

          for (var f in qo.filter || qo) {
            if (!ignoreDynamicFilter) {
              if (ignoredFilter(f)) {
                retFilter[f] = undefined;
              }
            }
            if (regexpFields.indexOf(f) >= 0) {
              retFilter[f] = getRegexp(retFilter[f]);
            }

            if (dateFields.indexOf(f) >= 0) {
              retFilter[f] = getDateField(retFilter[f]);
            } else {
              //console.log("Replace from ", retFilter[f], " to ", replaceInvalidChars(retFilter[f]));
              retFilter[f] = replaceInvalidChars(retFilter[f], f);
            }
          }

          if (qo.filter) {
            qo.filter = retFilter;
          } else {
            qo = retFilter;
          }

          if (sortingFields) {
            var sort = [];
            _.keys(sortingFields).forEach((key) => {
              sort = sort.concat(
                key
                  .split("+")
                  .map((k) => (sortingFields[key] === "desc" ? "-" + k : k))
              );
            });
            qo.sort = sort;
          }

          return qo;
        }

        function prepareQueryOptions(qo) {
          return qo;
        }

        function getQuery(url, query) {
          return url + "?" + query;
        }

        function doSearch(qo, previousQo) {
          return JSON.stringify(previousQo) !== JSON.stringify(qo);
        }

        function callServer(callerFunction, scopeVariable) {
          return function (tableState, tableController) {
            var qo = Utils.getTSQO(tableState);
            qo = Utils.prepareQueryOptions(qo);

            callerFunction(qo).then(
              function (data) {
                //console.log("get cards");
                scopeVariable = data;
                tableState.pagination.numberOfPages = data.metadata.pageCount;
                tableState.pagination.itemCount = data.metadata.count;
                tableState.pagination.pageFromItem = data.metadata.pageFromItem;
                tableState.pagination.pageToItem = data.metadata.pageToItem;
              },
              function (err) {}
            );
          };
        }

        function updateStateParamsFromFilter(filter, mapping) {
          //console.log(filter, mapping);

          var newParams = { bypass: true };
          //$state.current.reloadOnSearch = false;
          _.keys(mapping).forEach(function (key) {
            var filterFieldName = _.get(mapping, key + ".field", mapping[key]);
            var filterFieldType = _.get(mapping, key + ".type", "string");

            if (filterFieldName && filter) {
              //conversion of types
              if (
                !_.isNil(filter[filterFieldName]) &&
                filter[filterFieldName] !== ""
              ) {
                if (filterFieldType === "date") {
                  //TODO: function in locale sevice, which parse with given format and returns date or false (if not parseable)
                  var parsedDate = moment(
                    filter[filterFieldName],
                    LocaleService.getDateFormat("shortDate").toUpperCase()
                  );
                  if (parsedDate.isValid()) {
                    newParams[key] = parsedDate.format("DD.MM.YYYY");
                  }
                } else if (filterFieldType === "number") {
                  newParams[key] = filter[filterFieldName];
                } else {
                  newParams[key] = filter[filterFieldName];
                }
              } else {
                newParams[key] = undefined;
              }
              //$location.search(key,filter[filterFieldName]);
            }
          });

          if (timeout) {
            $timeout.cancel(timeout);
          }

          timeout = $timeout(function () {
            $state.go(".", newParams, { notify: false });
          }, 250);
          //$state.current.reloadOnSearch = true;
        }

        function updateFilterFromStateParams(filter, mapping) {
          var newFilter = {};

          filter = {};

          /*
           filter = {};*/

          //console.log("$stateParams: ", $stateParams);

          if (filter || true) {
            _.keys($stateParams).forEach(function (key) {
              if (mapping[key]) {
                var filterFieldName = _.get(
                  mapping,
                  key + ".field",
                  mapping[key]
                );
                var filterFieldType = _.get(mapping, key + ".type", "string");

                //console.log("update filter: ", 'filterFieldName=',filterFieldName, filterFieldType, filter[filterFieldName], "to: ", $stateParams[key]);
                if (filterFieldName) {
                  //console.log("key: ", key, $stateParams, $stateParams[key]);
                  if (!_.isNil($stateParams[key])) {
                    //conversion of types
                    if (filterFieldType === "number") {
                      //console.log("$stateParams[key] is number ", $stateParams[key]);
                      filter[filterFieldName] = parseFloat($stateParams[key]);
                    } else if (filterFieldType === "date") {
                      //console.log("$stateParams[key] is date ", filterFieldName, key, $stateParams[key]);
                      filter[filterFieldName] = moment(
                        $stateParams[key],
                        "DD.MM.YYYY"
                      ).format(
                        LocaleService.getDateFormat("shortDate").toUpperCase()
                      );
                    } else {
                      if (
                        _.isString($stateParams[key]) &&
                        $stateParams[key].length <= 0
                      ) {
                        //console.log("$stateParams[key] is empty string ", $stateParams[key]);
                        delete filter[filterFieldName];
                      } else {
                        //console.log("$stateParams[key] type is string ", $stateParams[key]);
                        filter[filterFieldName] = $stateParams[key];
                      }
                    }
                  } else {
                    //console.log("delete: ", filterFieldName, "from ", filter);
                    //console.log("$stateParams[key] is undefined", $stateParams[key]);
                    if (filter) {
                      delete filter[filterFieldName];
                    }
                  }
                } else {
                  //console.log("filterFieldName not set", filterFieldName);
                }
              }
            });

            //console.log("FILTER: ", filter);
            return filter;
          }

          //console.log("update filter: newFilter=",newFilter,"based on $stateParams=",$stateParams);
          //filter = _.assign(filter,newFilter);
        }

        function flatten(data) {
          var result = {};

          function recurse(cur, prop) {
            if (Object(cur) !== cur) {
              result[prop] = cur;
            } else if (Array.isArray(cur)) {
              result[prop] = cur;

              /*for(var i=0, l=cur.length; i<l; i++)
               recurse(cur[i], prop ? prop+"."+i : ""+i);
               if (l == 0)
               result[prop] = [];*/
            } else {
              var isEmpty = true;
              for (var p in cur) {
                isEmpty = false;
                recurse(cur[p], prop ? prop + "." + p : p);
              }
              if (isEmpty) {
                result[prop] = {};
              }
            }
          }

          recurse(data, "");
          return result;
        }

        function unflatten(data) {
          //console.log("input=", data);
          "use strict";
          if (Object(data) !== data || Array.isArray(data)) {
            return data;
          }
          var result = {},
            cur,
            prop,
            idx,
            last,
            temp;
          for (var p in data) {
            (cur = result), (prop = ""), (last = 0);
            do {
              idx = p.indexOf(".", last);
              temp = p.substring(last, idx !== -1 ? idx : undefined);
              cur = cur[prop] || (cur[prop] = !isNaN(parseInt(temp)) ? [] : {});
              prop = temp;
              last = idx + 1;
            } while (idx >= 0);
            cur[prop] = data[p];
          }
          //console.log("output=", result);
          return result[""];
        }

        function handleError(err, message) {
          if (message) {
            toastr.error(message);
          } /*else {  // No Message => Show nothing
        if (err.status) {
          if (err.statusText) {
            toastr.error(err.status, " - ", err.statusText);
          } else {
            toastr.error(err.status);
          }
        } else {
          if (err.statusText) {
            toastr.error(err.statusText);
          } else {
            toastr.error("unknown error");
          }
        }
      }*/
          if (err.status === 0) {
            $log.info("aborted request: ", err);
          } else {
            $log.error(err);
          }
        }

        function getSortQueryString(obj) {
          var qs = "";
          for (var k in obj) {
            if (obj[k] === "asc") {
              qs += "&sort=" + k;
            } else {
              qs += "&sort=-" + k;
            }
          }
          return qs;
        }

        function getQueryString(obj) {
          //var keys = Object.keys(obj);
          var qs = "";
          for (var k in obj) {
            if (obj[k] !== undefined && obj[k] !== null) {
              if (_.isArray(obj[k])) {
                for (var i = 0; i < obj[k].length; i++) {
                  qs += "&" + k + "=" + encodeURIComponent(obj[k][i]);
                }
              } else {
                if (_.isObject(obj[k])) {
                  if (k === "sort") {
                    var sortQueryString = getSortQueryString(obj[k]);
                    if (sortQueryString) {
                      qs += sortQueryString;
                    }
                  }
                  //ignore objects cause we can not make a query string out of them
                } else {
                  qs += "&" + k + "=" + encodeURIComponent(obj[k]);
                }
              }
            }
          }

          return qs.substr(1);
        }

        function prepareHeaders(action, headers) {
          var h = {};

          h[Constants.FRONTEND_ACTION_HEADER] = action;

          return _.assign(h, headers);
        }

        function replaceKeysAndValue(obj, from, to) {
          var retObj = {};
          for (var key in obj) {
            // TODO: move this to function
            retObj[key.replace(from, to)] = obj[key];
            if (typeof obj[key] === "string") {
              retObj[key.replace(from, to)] = obj[key].replace(from, to);
            }
          }
          return retObj;
        }

        function loadSyscodes(regex, asObj) {
          if (asObj) {
            return Object.keys(LocaleService.getListByRegexp(regex)).map(
              (key) => {
                return {
                  name: key,
                  value: key,
                };
              }
            );
          } else {
            return Object.keys(LocaleService.getListByRegexp(regex));
          }
        }

        return {
          prepareHeaders: prepareHeaders,
          doSearch: doSearch,
          getQueryString: getQueryString,
          getQuery: getQuery,
          handleError: handleError,
          getDateField: getDateField,
          prepareFilter: prepareFilter,
          callServer: callServer,
          getTableStateQueryOptions: getTSQO,
          getTSQO: getTSQO,
          prepareQueryOptions: prepareQueryOptions,
          updateStateParamsFromFilter: updateStateParamsFromFilter,
          updateFilterFromStateParams: updateFilterFromStateParams,
          flatten: flatten,
          unflatten: unflatten,
          processTree: processTree,
          replaceKeysAndValues: replaceKeysAndValue,
          loadSyscodes: loadSyscodes,
        };
      }]).name;



// WEBPACK FOOTER //
// ./src/ui/modules/dcb-eaccount/services/Utils.js